import React, { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultState = {
  userLoggedInText: 'Go to the dashboard'
};
var TextTokensContext = /*#__PURE__*/createContext(defaultState);
export var TextTokensProvider = function TextTokensProvider(_ref) {
  var children = _ref.children,
      initialState = _ref.initialState;
  return /*#__PURE__*/_jsx(TextTokensContext.Provider, {
    value: initialState,
    children: children
  });
};
export var useTextTokens = function useTextTokens() {
  return useContext(TextTokensContext);
};